export default __webpack_public_path__ + "static/media/Mumbai.ee7a65b3.webp";